/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weird_Key_Camel_OfferInputs */

const en_weird_key_camel_offer = /** @type {(inputs: Weird_Key_Camel_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select benchmark...`)
};

const de_weird_key_camel_offer = /** @type {(inputs: Weird_Key_Camel_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark auswählen...`)
};

/**
* | output |
* | --- |
* | "Select benchmark..." |
*
* @param {Weird_Key_Camel_OfferInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const weird_key_camel_offer = /** @type {((inputs?: Weird_Key_Camel_OfferInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weird_Key_Camel_OfferInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weird_key_camel_offer(inputs)
	return de_weird_key_camel_offer(inputs)
});